import React from 'react'

function Hero() {
  return (
    <section className="hero">
    <div className="container">
        <h1 className="text-center">
            Το κοινωνικό καζίνο Crazy Monkey Slot είναι μια μοναδική ευκαιρία να απολαύσετε όλη τη διασκέδαση που προσφέρει ένα παιχνίδι κουλοχέρηδων!
        </h1>
        <div className="inner-wrapper d-flex align-items-center justify-content-between mb-5">
            <div className="left-col">
                <img src="/1_(2).jpg" alt="hero img"/>
            </div>
            <div className="right-col">
                <p className="hero-text text">
                    Αυτή η δωρεάν ψυχαγωγία σας επιτρέπει να βυθιστείτε σε έναν συναρπαστικό κόσμο παιχνιδιών και να ζήσετε την ίδια αίσθηση ενός πραγματικού καζίνο, χωρίς να φύγετε από το σπίτι σας. 
                    Σχεδιασμένο για χρήση σε κινητές συσκευές και υπολογιστές, το παιχνίδι είναι διαθέσιμο σε iOS και Android, δίνοντάς σας την ευκαιρία να το απολαύσετε οπουδήποτε και οποτεδήποτε.
                </p>
            </div>
        </div>
        <p className="hero-text text text-md">
            Από την πρώτη στιγμή, θα σας συνεπάρει η γιορτινή ατμόσφαιρα του παιχνιδιού. Ζωντανά χρώματα και ελκυστικοί ήχοι δημιουργούν μια μοναδική οπτική και ακουστική εμπειρία. 
            Τα σύμβολα του παιχνιδιού, όπως χρυσά νομίσματα, φωτεινά φανάρια και ζουμερά φρούτα, σας μεταφέρουν σε μια εικονική γιορτή όπου κάθε περιστροφή είναι μια νέα ευκαιρία για διασκέδαση. 
            Το Crazy Monkey Slot προσφέρει μια αξέχαστη εμπειρία, κάνοντας κάθε παίκτη μέρος της κοινωνικής μας κοινότητας.
        </p>
    </div>
</section>

  )
}

export default Hero